import React from "react";
import { twMerge } from "tailwind-merge";

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  bordered?: boolean;
  className?: string;
  iconClassName?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action,
  bordered = false,
  className,
  iconClassName,
}) => {
  return (
    <div
      className={twMerge(
        "flex flex-col items-center justify-center gap-3 py-10 text-center",
        bordered &&
          "rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 p-10 sm:p-12",
        className
      )}
    >
      {icon && (
        <div
          className={twMerge(
            "flex h-12 w-12 items-center justify-center rounded-full bg-gray-100 text-gray-400",
            iconClassName
          )}
        >
          {icon}
        </div>
      )}
      <div className="max-w-sm">
        <p
          className={twMerge(
            "text-sm",
            description ? "font-medium text-gray-700" : "text-gray-500"
          )}
        >
          {title}
        </p>
        {description && (
          <p className="mt-1 text-sm text-gray-500">{description}</p>
        )}
      </div>
      {action && <div className="mt-1">{action}</div>}
    </div>
  );
};

export default EmptyState;
